import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./home.scss";
import Utils from "../../utils/utils";
import { HideLoading, ShowLoading } from "../../components/Loading/index"
import { AppApiInstance } from "../../api/app-api";
import { Actions, SESSION_KEYS } from "../../api/const";
import { fromBase64, toBase64 } from "js-base64";

const HomeScreen = ({ gameInfo, shareKey, gid }) => {
  const startTime = new Date().getTime();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [usingIframeUrl, setUsingIframeUrl] = useState('');
  const [inpuData, setInpuData] = useState({
    appid: 0,
    action: '',
    identifier: '',
    source: '',
    redirecturl: '',
    bdata: '',
    ts: 0,
    sig: '',
    response_data: '',
    zptranstoken: '',
    amount: 0,
    app_trans_id: '',
    zptransid: '',
    status: '',
    bindingId: '',
  });

  const siteUrl = window['runtime_configs'].REACT_APP_SITE_URL;
  const loginUrl = window['runtime_configs'].REACT_APP_LOGIN_URL;
  const sourceConfids = window['runtime_configs'].UM_SOURCE_CONFIGS;

  const processH5Flow = (data, permission, action) => {
    if (permission.return_code == 1) {
      if (!permission.using_iframe) {
        console.log('go to h5 page')
        gotoPage(data, permission, action)
      } else {
        console.log('load h5 in iframe')
        gotoPage(data, permission, action)
      }
    } else if (permission.return_code == 7) {//login
      console.log('go to login')
      gotoLogin();
    } else {
      console.log('go to error page')
      gotoError();
    }
  }
  //{"return_code":1,"return_message":"SUCCESS","using_iframe":false,"actions":[{"name":"login","using_iframe":false,"url":"https://socialstg.zalopay.vn/um-spa/login-register?cb_url=","h5_callback_url":"https://zlpdev-h5p.zalopay.vn/login"},{"name":"cashier","using_iframe":false,"url":"https://socialstg.zalopay.vn/spa/v2/merchant?order=","h5_callback_url":"https://zlpdev-h5p.zalopay.vn/cashier"}]}
  const checkPermission = (data) => {
    let params = {
      "app_id": data.appid,
      "identifier": data.identifier,
      "action": data.action,
      "ts": data.ts,
      "sig": data.sig,
      "json_data": data.bdata
    }
    AppApiInstance.checkPermission(params).then(rs => {
      //setPermission(permission)
      //console.log(rs)
      if (rs.return_code == 1) {
        inpuData.response_data = rs.return_message;
        setInpuData(inpuData);
      }
      processH5Flow(data, rs, params.action);
    }).catch(err => {

    });

    showLoading(false);
  }
  const saveTrackingLog = (action, data, metadata, promotiondata) => {
    let fullMetaData = { ...data, ...metadata };
    let params = {
      "app_id": data.appid ?? 0,
      "identifier": data.identifier ?? '',
      "action": action ?? '',
      "client_id": data.appid + '',
      "source": data.source ?? '',
      "redirecturl": data.redirecturl ?? '',
      "zptranstoken": data.zptranstoken ?? '',
      "user_id": data.response_data ?? '',
      "amount": data.amount + '',
      "app_trans_id": data.app_trans_id ?? '',
      "zptransid": data.zptransid ?? '',
      "status": data.status ?? '',
      "metadata": JSON.stringify(fullMetaData) ?? '',
      "timestamp": data.ts,
      "promotiondata": JSON.stringify(promotiondata) ?? '',
      "ymd": '',
      "extra_info": "",
      "session_id": "",
      "url": window.location.href ?? ''
    }
    AppApiInstance.saveTracking(params).then(rs => {
      console.log('saveTracking succ: ', params, rs)
    }).catch(err => {
      console.log('saveTracking fail: ', params, err)
    });
  }
  const showLoading = (enable) => {
    setIsLoading(enable);
    if (enable) {
      ShowLoading();
    } else {
      //HideLoading();
    }
  }

  const gotoLogin = () => {
    let returnUrl = siteUrl + '?fromLogin=1';
    let source = inpuData.appid;
    let bindingId = ''
    const now = new Date();
    try {
      if (inpuData?.bdata !== '') {
        let bBindingData = JSON.parse(fromBase64(inpuData?.bdata));
        bindingId = bBindingData?.btoken
      }
      let fullLoginUrl = loginUrl + encodeURIComponent(returnUrl) + "&source=" + source;
      if (bindingId && bindingId.length > 0) {
        fullLoginUrl += '&bindingId=' + bindingId + '&ts=' + now.getTime();
      }
  
      let dataLog = { ...inpuData };
      dataLog.redirecturlto = fullLoginUrl;
      saveTrackingLog(getLogAction(Actions.LOGIN, false), dataLog, { url: window.location.href }, {});
      window.location.href = fullLoginUrl;
    } catch (error) {
      console.log('an error occurred', error)
    }
  }

  const gotoError = () => {
    let errorUrl = siteUrl + 'error';
    saveTrackingLog(getLogAction(Actions.ERROR, false), { ...inpuData }, { url: window.location.href, errorurl: errorUrl }, {});
    window.location.replace(errorUrl);
  }

  const createUrlByAction = (data, actionObj, action, returnUrl) => {
    let url = '';
    let dataLog = { ...inpuData };
    switch (action) {
      case Actions.CASHIER:
        //let order = '{"zptranstoken":"'+orderInfo.zptranstoken+'","appid":'+orderInfo.appid+',"redirecturl":"'+redirectToMCURL+'"}';
        let bData = JSON.parse(fromBase64(data.bdata));
        bData.redirecturl = returnUrl;
        url = actionObj.url + toBase64(JSON.stringify(bData)) + '&redirecturl=' + encodeURIComponent(returnUrl);
        //tra
        dataLog.redirecturlto = url;
        dataLog.zptranstoken = bData.zptranstoken;
        saveTrackingLog(getLogAction(Actions.CASHIER, false), dataLog, { url: window.location.href }, {});
        break;
      case Actions.TOPUP:
        //`${ZPI_TOP_UP_URL}?order_amount=${rawAmount}&cb_url=${encodeURIComponent(callbackURL)}`
        //bdata = amount
        url = actionObj.url + `?order_amount=${bData}&cb_url=${encodeURIComponent(returnUrl)}`;
        dataLog.amount = bData.bdata;
        dataLog.redirecturlto = url;
        saveTrackingLog(getLogAction(Actions.TOPUP, false), dataLog, { url: window.location.href }, {});
        break;
      case Actions.BINDING:
        //bdata = amount
        let bBindingData = JSON.parse(fromBase64(data.bdata));
        url = actionObj.url + `${bBindingData.btoken}&redirect_url=${encodeURIComponent(returnUrl)}&s=h5`;
        //dataLog.amount = bData.bdata;
        dataLog.redirecturlto = url;
        saveTrackingLog(getLogAction(Actions.BINDING, false), dataLog, { url: window.location.href }, bBindingData);
        break;
      case Actions.GG_BINDING:
        let bindingURL = new URL(actionObj.url)
        let ggBindingData = JSON.parse(fromBase64(data.bdata)) ?? {};
        if (ggBindingData?.gspAuthenticationRequest) {
          bindingURL.searchParams.append("gspAuthenticationRequest", ggBindingData.gspAuthenticationRequest);
        }
        if (ggBindingData?.gspCallbackUrl) {
          bindingURL.searchParams.append("redirect_url", ggBindingData.gspCallbackUrl);
        }
        bindingURL.searchParams.append("s", "h5");
        saveTrackingLog(getLogAction(Actions.GG_BINDING, false), dataLog, { url: window.location.href }, ggBindingData);
        url = bindingURL.toString();
        break;
      default:
        break;
    }
    return url;
  }
  const gotoPage = (data, permission, action) => {
    let returnUrl = siteUrl + `?fromAction=1&doneaction=${action}`;
    let url = '';
    let usingIframe = false;
    let l = permission.actions?.length;
    for (let i = 0; i < l; i++) {
      let item = permission.actions[i];
      if (action == item.name) {
        let usingIframeParam = '0';
        if (item.using_iframe) {
          usingIframeParam = '1';
          usingIframe = true;
        }
        url = createUrlByAction(data, item, action, returnUrl + '&zlph5actionloadiniframe=' + usingIframeParam);
      }
    }
    //url = 'https://socialdev.zalopay.vn/um-spa/login-register?cb_url=https%3A%2F%2Fzlpqc-h5p.zalopay.vn%2F%3FfromLogin%3D1&source=merchant_tiktoklive';
    if (url != '') {
      if (usingIframe) {
        setUsingIframeUrl(url);
        HideLoading();
      } else {
        window.location.href = url;
      }
    } else {
      console.log('url is null')
      gotoError();
    }
  }
  const iframeStyle = {
    height: '100vh',
    width: '100vw'
  };

  const getLogAction = (action, isBack) => {
    let outAction = '';
    switch (action) {
      case Actions.ENTER:
        outAction = 'MiddlepageH5Redirect';
        break;
      case Actions.LOGIN:
        outAction = 'H5LogIn';
        if (isBack) outAction = 'H5loginredirect';
        break;
      case Actions.CASHIER:
        outAction = 'H5cashier';
        if (isBack) outAction = 'H5cashierredirect';
        break;
      case Actions.MAP_BANK:
        outAction = 'H5mapbank';
        if (isBack) outAction = 'H5mapbankRedirect';
        break;
      case Actions.TOPUP:
        outAction = 'H5topup';
        if (isBack) outAction = 'H5topupredirect';
        break;
      case Actions.UPDATE_KYC:
        outAction = 'H5upgradekyc';
        if (isBack) outAction = 'H5upgradekycRedirect';
        break;
      case Actions.BINDING:
        outAction = 'H5Binding';
        if (isBack) outAction = 'H5BindingRedirect';
        break;
      case Actions.ERROR:
        outAction = 'H5error';
        break;
    }
    return outAction;
  }
  const createBackLink = (url) => {
    let newUrl = '';
    let qString = window.location.search;
    qString = qString.replace('fromAction', 'zlph5fromaction');
    qString = qString.replace('doneaction', 'zlph5doneaction');

    if (url.indexOf('?') !== -1) {
      qString = qString.replace('?', '');
      newUrl = url + '&' + qString;
    } else {
      newUrl = url + qString;
    }
    return newUrl;
  }
  const isValidUrl = (urlString) => {
    let url;
    try {
      url = new URL(urlString);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }
  useEffect(() => {
    showLoading(true);
    let data = { appid: 0 };
    //let fullUrl = window.location.href;
    //console.log(fullUrl)
    //sessionStorage.setItem('logUrl', fullUrl)
    //check from action
    let fromAction = Utils.getParameterByName("fromAction");
    let doneaction = Utils.getParameterByName("doneaction");

    //zlph5actionloadiniframe
    let loadInIframe = Utils.getParameterByName("zlph5actionloadiniframe");
    if (fromAction + '' == '1') {
      let returnBackToMerchantFromURL = Utils.getParameterByName("redirecttomerchant");
      let returnBackToMerchant = '';
      if (!Utils.empty(returnBackToMerchantFromURL)) {
        if (!isValidUrl(returnBackToMerchantFromURL)) {
          return gotoError();
        }
        returnBackToMerchant = returnBackToMerchantFromURL;
      }
      saveTrackingLog(getLogAction(doneaction, true), { ...inpuData, redirecturlto: returnBackToMerchant }, { url: window.location.href }, {});

      if (Utils.empty(returnBackToMerchant)) {
        return gotoError();
      }

      if (loadInIframe == '1') {
        window.parent.location.href = returnBackToMerchant;
      } else {
        window.location.href = returnBackToMerchant;
      }
      return;
    }

    let fromLogin = Utils.getParameterByName("fromLogin");
    if (fromLogin + '' == '1') {
      let b = sessionStorage.getItem(SESSION_KEYS.H5_SESSION_DATA);
      data = Utils.decodeData(b);
      setInpuData(data);

      saveTrackingLog(getLogAction(Actions.LOGIN, true), { ...data }, { url: window.location.href }, {});
    } else {
      //https://sbgateway.zalopay.vn/openinapp?order=eyJ6cHRyYW5zdG9rZW4iOiIyMjA1MDMwMDAwNTE3MTEzM3ZHM3cxIiwiYXBwaWQiOjU1M30
      let appid = Utils.getParameterByName("appid");
      let action = Utils.getParameterByName("action");
      let identifier = Utils.getParameterByName("identifier");
      let source = Utils.getParameterByName("source");
      let redirecturl = Utils.getParameterByName("redirecturl");
      let bdata = Utils.getParameterByName("bdata");
      let ts = Utils.getParameterByName("ts");
      let sig = Utils.getParameterByName("sig");

      if (Utils.empty(appid) ||
        Utils.empty(action) ||
        Utils.empty(identifier) ||
        //Utils.empty(source) || 
        Utils.empty(redirecturl) ||
        Utils.empty(ts) ||
        Utils.empty(sig)
      ) {
        console.log("invalid param!")
        //gotoError();
      }

      data = {
        appid: parseInt(appid),
        action: action,
        identifier: identifier,
        source: source,
        redirecturl: redirecturl,
        bdata: bdata,
        ts: parseFloat(ts),
        sig: sig,
      }
      setInpuData(data);

      let b = Utils.encodeData(data);
      sessionStorage.setItem(SESSION_KEYS.H5_SESSION_DATA, b);

      saveTrackingLog(getLogAction(Actions.ENTER, false), { ...data }, { url: window.location.href }, {});
    }
    if (data.appid == 0) {
      return gotoError();
    }
  }, []);
  useEffect(() => {
    if (inpuData.appid > 0) {
      checkPermission({ ...inpuData });
    }
  }, [inpuData]);

  //"#0068FF",
  const ui = () => {
    return (
      <>
        {usingIframeUrl &&
          <div style={{backgroundColor: '#ffffff'}}>
            <iframe id={"iframeID" + inpuData.appid} style={iframeStyle} src={usingIframeUrl} />
          </div>
        }
        {!isLoading && !usingIframeUrl &&
          <div
            className={"flex-v-center column home-page-screen"}
            style={{
              backgroundColor: "#FFF",
            }}
          >
            <div className="hv2-banner-wp">
              <div className="hv2-banner"></div>
            </div>
          </div>
        }
      </>
    );
  };
  return ui();
};

export default HomeScreen;
